import React from 'react'
import { motion } from 'framer-motion'
import img from '../assets/experience/lior.jpg'

function ExperienceCard({role,companyName,period,summary}) {
  return (
    <article 
    className='flex flex-col rounded-lg items-center space-y-1 flex-shrink-0 
    w-[400px]  xl:w-[500px] snap-center bg-[#292929] p-10 
    hover:opacity-100 opacity-40 cursor-pointer transition-opacity duration-200 overflow-hidden'>
      
      <motion.img
      initial={{
        y: -100,
        opacity:0,
      }}
      transition={{duration:1.2}}
      whileInView={{opacity:1, y:0}}
      viewport={{once: false}}
      className='w-[100px] h-[100px] rounded-full object-cover object-center'
      src={img} alt=""
      />

      <div className='px-0 md:px-10 '>
        <h4 className='text-1xl font-light  sm:text-2xl'>{role}</h4>
        <div className='font-bold text-0.5xl mt-1  sm:1xl'>{companyName}</div>
          <div className='uppercase py-5 text-gray-300 text-0.5xl mt-1  sm:1xl'>
            {period}
          </div>
          
          <ul className='list-disc space-y-4 ml-5 text-0.5xl sm:1xl'>
            <li>{summary}</li>
            
          </ul>
      </div>

      
    </article>
  )
}

export default ExperienceCard